import React, { useState } from 'react';

const FeatureCard = ({ title, description, onHover }) => {
  return (
    <div 
      className="bg-white p-6 rounded-lg shadow-md transition-all duration-300 ease-in-out hover:shadow-lg"
      onMouseEnter={() => onHover(title)}
    >
      <h4 className="text-xl font-bold text-gadventures-purple-dark mb-2">{title}</h4>
      <p className="text-gray-600">{description}</p>
    </div>
  );
};

const WhyChooseGadventures = () => {
  const [activeFeature, setActiveFeature] = useState('Small Groups');

  const features = [
    {
      title: "Small Groups",
      description: "Travel with like-minded adventurers in intimate groups of 12-16 people, ensuring authentic local experiences and meaningful connections.",
      image: "/smallGroups.jpg"
    },
    {
      title: "Local Experiences",
      description: "Immerse yourself in local cultures with authentic homestays, traditional cooking classes, and meaningful interactions with communities.",
      image: "/localExperiences.jpg" 
    },
    {
      title: "Sustainable Travel",
      description: "Make a positive impact with our commitment to responsible tourism, supporting local communities and protecting the environments we explore.",
      image: "/sustainable.jpg"
    },
    {
      title: "Expert Guides",
      description: "Journey with knowledgeable local guides who share deep insights into the culture, history, and hidden gems of each destination.",
      image: "/guides.jpg"
    }
  ];

  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            Why Travel with <span className="text-gadventures-purple">G Adventures</span>?
          </h2>
          <div className="flex items-center justify-center gap-2 mt-4">
            <img src="/Flag_of_Canada.svg" alt="Canadian Flag" className="w-6 h-6" />
            <span className="text-lg font-semibold text-gray-700">Canadian Company Since 1990</span>
            <img src="/Flag_of_Canada.svg" alt="Canadian Flag" className="w-6 h-6" />
          </div>
          <p className="mt-4 text-xl text-gray-600 flex items-center justify-center">
            Proudly Canadian owned and operated, delivering authentic adventures that combine cultural immersion with sustainable travel practices.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8">
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-bold text-gadventures-purple-dark mb-4">
                Authentic Adventure Travel
              </h3>
              <p className="text-gray-600 mb-6">
                Join G Adventures for transformative journeys that combine adventure, cultural immersion, and responsible tourism to create unforgettable travel experiences.
              </p>
            </div>
            <div className="relative pb-[100%] md:pb-0 h-[400px]">
              <img
                src={features.find(f => f.title === activeFeature).image}
                alt={activeFeature}
                className="rounded-lg shadow-xl w-full h-full object-cover transition-opacity duration-300 ease-in-out"
              />
            </div>
          </div>

          <div className="space-y-8 mt-16 md:mt-0">
            <div>
              <h3 className="text-2xl font-bold text-gadventures-purple-dark mb-4">
                Life-Changing Experiences
              </h3>
              <p className="text-gray-600 mb-6">
                Our carefully crafted itineraries blend adventure with cultural authenticity, creating meaningful connections and lasting memories in every destination.
              </p>
            </div>
            <div className="grid grid-cols-1 gap-6">
              {features.map((feature) => (
                <FeatureCard
                  key={feature.title}
                  title={feature.title}
                  description={feature.description}
                  onHover={setActiveFeature}
                />
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 flex justify-center space-x-2">
          {[...Array(6)].map((_, index) => (
            <div
              key={index}
              className="w-2 h-2 rounded-full bg-gadventures-purple"
            ></div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseGadventures;
